:host([disabled]) {
  div.actions > * {
    pointer-events: none;
    opacity: 0.6;
  }
}

.smart-views-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.actions {
  height: calc(var(--spacer) * 3);
  display: flex;
  align-items: center;
  gap: calc(var(--spacer) * 2);
}

.divider {
  height: calc(var(--spacer) * 2);
  width: 1px;
  margin: 0 calc(var(--spacer) * 2) 0 calc(var(--spacer) * 0.5);
  background-color: var(--chart-101-pressed-dividers);
}
